import { Component, inject, input } from '@angular/core'

import { IonicModule } from '@ionic/angular'
import { ModalController } from '@ionic/angular/standalone'
import { TranslocoPipe } from '@jsverse/transloco'
import { ErrorResponseDTO } from 'src/app/core/error-response.model'

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    
    imports: [IonicModule, TranslocoPipe]
})
export class ErrorModalComponent {

  readonly error = input<ErrorResponseDTO>()

  private readonly modalController = inject(ModalController)

  get errorMessage () {
    return `errorCodes.${this.error()?.errorCode || this.error()?.message || (this.error() as any)?.statusText}` || 'unknown_error'
  }

  close () {
    this.modalController.dismiss()
  }

}
